/* eslint @typescript-eslint/explicit-function-return-type: off */

import React from 'react';
import PropTypes from 'prop-types';
import * as BS from 'react-bootstrap';
import Project from '../../models/Project';
import AdAccount from '../../models/AdAccount';
import CsvImportJob from '../../models/CsvImportJob';
import * as Resource from '../../apis/CsvImportJob';
import * as Routes from '../../routes/CsvImportJob';
import Form from './Form';

const scope = 'frontend.components.CsvImportJob.FormModal';

const propTypes = {
  project: PropTypes.exact(Project.propTypes),
  adAccounts: PropTypes.arrayOf(PropTypes.exact(AdAccount.propTypes)),
  job: PropTypes.exact(CsvImportJob.propTypes),
  shown: PropTypes.bool,
  onHide: PropTypes.func,
};

class FormModal extends React.Component {
  static propTypes = propTypes;

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.sendRequest = this.sendRequest.bind(this);

    const { job } = props;
    this.state = {
      job: job || CsvImportJob.initialProps(),
      submitting: false,
    };
  }

  handleChange(job) {
    this.setState({ job });
  }

  handleSubmit(event) {
    event.preventDefault();

    this.setState({ submitting: true });

    return this.sendRequest()
      .then((job) => {
        const { sourceFile } = this.state.job;
        Object.assign(job, { sourceFile });

        this.setState({ job });
        if (job.errors) {
          this.setState({ submitting: false });
          return;
        }

        const { project } = this.props;
        location.href = Routes.detailsPath(project.id, job.id);
      })
      .catch((error) => {
        console.error(error);
        alert(I18n.t(`${scope}.message.error_occurred`));
        this.setState({ submitting: false });
      });
  }

  sendRequest() {
    const { project } = this.props;
    const { job: jobParams } = this.state;
    return Resource.create(project.id, jobParams);
  }

  render() {
    const { project, adAccounts, shown, onHide } = this.props;
    const { job: jobProps, submitting } = this.state;

    return (
      <BS.Modal show={shown} onHide={onHide} bsSize='large'>
        <BS.Modal.Header closeButton>
          <BS.Modal.Title>{I18n.t(`${scope}.title`)}</BS.Modal.Title>
        </BS.Modal.Header>
        <BS.Modal.Body>
          {adAccounts.length == 0 && (
            <BS.Alert bsStyle='warning'>
              <i className='fa fa-warning icon' />
              <span
                dangerouslySetInnerHTML={{
                  __html: I18n.t(
                    `${scope}.message.manual_ad_account_not_created`,
                    {
                      new_project_ad_account_path: `/projects/${project.id}/accounts/new?locale=${I18n.locale}&via=list#manual-channels-selection`,
                    }
                  ),
                }}
              ></span>
            </BS.Alert>
          )}
          <Form
            project={project}
            adAccounts={adAccounts}
            job={new CsvImportJob(jobProps)}
            onChange={this.handleChange}
          />
        </BS.Modal.Body>
        <BS.Modal.Footer>
          <BS.Button onClick={onHide}>
            {I18n.t(`${scope}.action.close`)}
          </BS.Button>
          <BS.Button
            bsStyle='primary'
            onClick={this.handleSubmit}
            disabled={adAccounts.length == 0 || submitting}
          >
            {I18n.t(`${scope}.action.create`)}
          </BS.Button>
        </BS.Modal.Footer>
      </BS.Modal>
    );
  }
}

export default FormModal;
